"use strict";

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

function normalizeEndpoint(endpoint, urlParser) {
  if (typeof endpoint === "string") {
    var promisified_1 = Promise.resolve(urlParser(endpoint));
    return function () {
      return promisified_1;
    };
  } else if (typeof endpoint === "object") {
    var promisified_2 = Promise.resolve(endpoint);
    return function () {
      return promisified_2;
    };
  }

  return endpoint;
}

exports.normalizeEndpoint = normalizeEndpoint;

function resolveEndpointsConfig(input) {
  var _this = this;

  var tls = input.tls === undefined ? true : input.tls;
  var endpoint = input.endpoint ? normalizeEndpoint(input.endpoint, input.urlParser) : function () {
    return input.region().then(function (region) {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var hostname, endpoint;
        return tslib_1.__generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , input.regionInfoProvider(region)];

            case 1:
              hostname = (_a.sent() || {}).hostname;

              if (!hostname) {
                throw new Error("Cannot resolve hostname from client config");
              }

              endpoint = input.urlParser((tls ? "https:" : "http:") + "//" + hostname);
              return [2
              /*return*/
              , endpoint];
          }
        });
      });
    });
  };
  return tslib_1.__assign(tslib_1.__assign({}, input), {
    endpoint: endpoint,
    tls: tls
  });
}

exports.resolveEndpointsConfig = resolveEndpointsConfig;